/**
 * Created by neo on 11.01.21.
 */
import { makeAutoObservable } from 'mobx';
import { ExploreEntry, createExploreEntry } from './ExploreEntry';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { v1ParamsToV3Params } from './exploreV3Params';
import { ExploreEntryQueryRequest } from './ExploreEntryQueryRequest';

export type LinkEntry = ExploreEntry & {
  type: 'link';
  link: string;
};

export function createLinkEntry(json?: Partial<LinkEntry>): LinkEntry {
  const base = createExploreEntry({ ...json, type: 'link' });
  return makeAutoObservable({
    ...base,
    type: 'link' as const,
    link: json?.link ?? '',
  });
}

export const LinkEntryApi = {
  find(request: Omit<ExploreEntryQueryRequest, 'type'>): Promise<LinkEntry[]> {
    return HttpBackend.get(`/coach/explore/v3/entries`, v1ParamsToV3Params({ ...request, type: 'link' })).then((res) =>
      (res ?? []).map((r: any) => createLinkEntry(r)),
    );
  },

  findOne(id: string): Promise<LinkEntry> {
    return HttpBackend.get(`/coach/explore/v3/entries/${id}`).then((res) => createLinkEntry(res));
  },
};
